var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVoxistAsr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    enableBackground: "new 0 0 2048 2048",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "top_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000028318058658864609690000011060944216979359400_",
    gradientUnits: "userSpaceOnUse",
    x1: 857.321,
    y1: 2043.1674,
    x2: 1858.3544,
    y2: 1042.134,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    fill: "url(#XMLID_00000028318058658864609690000011060944216979359400_)",
    d: "M1723.8,895 c0,51.7-41.9,93.7-93.7,93.7c-51.8,0-93.7-41.9-93.7-93.7V660.2c0-51.7,41.9-93.7,93.7-93.7c51.8,0,93.7,42,93.7,93.7V895z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000065793538447998880400000009562242383827653271_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2009,
    y1: 1437.0472,
    x2: 1252.2344,
    y2: 436.0139,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    fill: "url(#XMLID_00000065793538447998880400000009562242383827653271_)",
    d: "M511.6,895 c0,51.7-41.9,93.7-93.7,93.7s-93.7-41.9-93.7-93.7V660.2c0-51.7,41.9-93.7,93.7-93.7s93.7,42,93.7,93.7V895z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000116219784234824774810000014043894458000842922_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.7309,
    y1: 1588.5773,
    x2: 1403.7643,
    y2: 587.5439,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    fill: "url(#XMLID_00000116219784234824774810000014043894458000842922_)",
    d: "M627.3,352.4 c0-51.7,41.9-93.7,93.7-93.7s93.7,42,93.7,93.7v850.5c0,51.7-41.9,93.7-93.7,93.7s-93.7-41.9-93.7-93.7V352.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000098181738201817301400000016003552690231579037_",
    gradientUnits: "userSpaceOnUse",
    x1: 705.7909,
    y1: 1891.6373,
    x2: 1706.8245,
    y2: 890.6039,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    fill: "url(#XMLID_00000098181738201817301400000016003552690231579037_)",
    d: "M1233.4,352.4 c0-51.7,41.9-93.7,93.7-93.7c51.7,0,93.7,42,93.7,93.7v850.5c0,51.7-41.9,93.7-93.7,93.7c-51.7,0-93.7-41.9-93.7-93.7V352.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000087404608623001140650000006056094158158437762_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.7783,
    y1: 1772.6246,
    x2: 1587.8118,
    y2: 771.5912,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    fill: "url(#XMLID_00000087404608623001140650000006056094158158437762_)",
    d: "M930.3,222.3 c0-51.7,41.9-93.7,93.7-93.7c51.8,0,93.7,42,93.7,93.7v980.6c0,51.7-41.9,93.7-93.7,93.7c-51.8,0-93.7-41.9-93.7-93.7V222.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000155128235628050155470000014980541818239204021_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.0584,
    y1: 1433.9048,
    x2: 1249.0918,
    y2: 432.8714,
    gradientTransform: "matrix(1 0 0 -1 0 2048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    fill: "url(#XMLID_00000155128235628050155470000014980541818239204021_)",
    d: "M1117.7,1202.9 c0,141.6-113.6,260.5-255.2,259.7c-16.1-0.1-31.8-1.7-47.1-4.7c-16-3.2-19.9-24.4-5.9-32.9c72.5-44.6,120.8-124.7,120.8-216.1"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.2718,
    y1: 1346.5023,
    x2: 1831.8718,
    y2: 1346.5023,
    gradientTransform: "matrix(1 0 0 1 -118.1793 256.9161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    stroke: "#00D7C4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M1685.7,1631.4H342 c-15.4,0-28-12.5-28-28l0,0c0-15.4,12.5-28,28-28h1343.7c15.4,0,28,12.5,28,28l0,0C1713.7,1618.9,1701.2,1631.4,1685.7,1631.4z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M882.9,1736.3c3.5-3.7,7.4-5,11.1-5c7.4,0,13.4,5.7,13.4,12.8v130.7c0,7-6,12.8-13.4,12.8 c-7.6,0-13.6-5.9-13.6-12.8v-21.1h-31.4c-7.2,0-12.7-5.2-12.7-12c0-6.5,5.5-12,12.7-12h31.4v-53.1l-94.8,106.7 c-2.3,2.4-6.5,4.4-9.9,4.4c-6.9,0-12.7-5.4-12.7-12c0-2.6,0.7-5,3-7.8L882.9,1736.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M931.4,1852.4c0-7,6-12.6,13.4-12.6c6.2,0,9.7,3.3,11.8,7.2c3.2,7.2,9.9,17,25.4,17 c14.1,0,24-10.2,24-21.8c0-13.9-12.7-18.9-24.7-22.4l-11.8-3.3c-15.9-4.8-36.7-14.6-36.7-43.1c0-24.2,21.3-42.3,49.2-42.3 c29.4,0,48.3,19.4,48.3,33.8c0,7-6,12.6-13.4,12.6c-6.2,0-9.5-3.3-11.3-7.2c-3.2-6.8-9.5-15.5-23.6-15.5c-12.9,0-22,9.4-22,20 c0,13.3,13.2,18.3,22.9,20.9l10.2,3c17.1,5,40.2,13.7,40.2,45.1c0,24.6-22.4,44-51.3,44C952.9,1887.9,931.4,1867.4,931.4,1852.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1058.6,1745.9c0-7,6.2-12.6,13.6-12.6h39.3c30.3,0,50.8,20.5,50.8,45.7c0,20.9-13.9,35.3-30,39l-3,0.2 l43,48.3c2.5,2.8,3.2,5.4,3.2,8.5c0,7-6,12.6-13.4,12.6c-4.2,0-7.9-1.5-10.6-4.8l-54.1-60.5c-1.8-2.2-4.2-5.7-4.2-10 c0-6.5,5.5-11.5,12.2-11.5h5.1c13.9,0,23.6-9.8,23.6-21.8c0-12.2-9.7-22-23.6-22h-24.7v117.8c0,7-6.2,12.8-13.6,12.8 c-7.4,0-13.6-5.9-13.6-12.8V1745.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012465814421625159440000014687335509459361176_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.9473,
    y1: 1809.4761,
    x2: 1175.5078,
    y2: 1809.4761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000012465814421625159440000014687335509459361176_)",
    d: "M882.9,1736.3c3.5-3.7,7.4-5,11.1-5 c7.4,0,13.4,5.7,13.4,12.8v130.7c0,7-6,12.8-13.4,12.8c-7.6,0-13.6-5.9-13.6-12.8v-21.1h-31.4c-7.2,0-12.7-5.2-12.7-12 c0-6.5,5.5-12,12.7-12h31.4v-53.1l-94.8,106.7c-2.3,2.4-6.5,4.4-9.9,4.4c-6.9,0-12.7-5.4-12.7-12c0-2.6,0.7-5,3-7.8L882.9,1736.3 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075132494203567019350000017116186175192983176_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.9473,
    y1: 1809.4761,
    x2: 1175.5078,
    y2: 1809.4761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000075132494203567019350000017116186175192983176_)",
    d: "M931.4,1852.4c0-7,6-12.6,13.4-12.6 c6.2,0,9.7,3.3,11.8,7.2c3.2,7.2,9.9,17,25.4,17c14.1,0,24-10.2,24-21.8c0-13.9-12.7-18.9-24.7-22.4l-11.8-3.3 c-15.9-4.8-36.7-14.6-36.7-43.1c0-24.2,21.3-42.3,49.2-42.3c29.4,0,48.3,19.4,48.3,33.8c0,7-6,12.6-13.4,12.6 c-6.2,0-9.5-3.3-11.3-7.2c-3.2-6.8-9.5-15.5-23.6-15.5c-12.9,0-22,9.4-22,20c0,13.3,13.2,18.3,22.9,20.9l10.2,3 c17.1,5,40.2,13.7,40.2,45.1c0,24.6-22.4,44-51.3,44C952.9,1887.9,931.4,1867.4,931.4,1852.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005980042583013849680000008687034319577665431_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.9473,
    y1: 1809.4761,
    x2: 1175.5078,
    y2: 1809.4761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#00D7C4"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000005980042583013849680000008687034319577665431_)",
    d: "M1058.6,1745.9c0-7,6.2-12.6,13.6-12.6h39.3 c30.3,0,50.8,20.5,50.8,45.7c0,20.9-13.9,35.3-30,39l-3,0.2l43,48.3c2.5,2.8,3.2,5.4,3.2,8.5c0,7-6,12.6-13.4,12.6 c-4.2,0-7.9-1.5-10.6-4.8l-54.1-60.5c-1.8-2.2-4.2-5.7-4.2-10c0-6.5,5.5-11.5,12.2-11.5h5.1c13.9,0,23.6-9.8,23.6-21.8 c0-12.2-9.7-22-23.6-22h-24.7v117.8c0,7-6.2,12.8-13.6,12.8c-7.4,0-13.6-5.9-13.6-12.8V1745.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoxistAsr);
export default __webpack_public_path__ + "static/media/logo_voxist_asr.9662c6e97629966ecd0408e1f8a9168a.svg";
export { ForwardRef as ReactComponent };